module.exports = __webpack_public_path__ + "static/img/gptzixun.ac42f3f7.png";